import { useState } from "react";
import { Check, Hash } from "lucide-react";

function shortId(uuid: string): string {
  return uuid.slice(0, 8);
}

export default function ChatUuidPill({ value }: { value?: string }) {
  const uuid = typeof value === "string" ? value : "";
  const [copied, setCopied] = useState(false);

  if (!uuid) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(uuid);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard can fail in non-secure contexts */
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      title={copied ? "Copied" : uuid}
      aria-label={copied ? `Copied ${uuid}` : `Copy id ${uuid}`}
      className="mx-0.5 inline-flex translate-y-px cursor-pointer items-center gap-1 rounded-tag bg-co-surface-solid px-1.5 py-px align-middle font-mono text-[10.5px] font-medium text-co-text2 transition-colors hover:border-co-line2 hover:bg-co-hover hover:text-co-text"
    >
      {copied ? (
        <Check className="size-2.5 shrink-0 text-co-live" strokeWidth={2.5} />
      ) : (
        <Hash className="size-2.5 shrink-0 text-co-faint" strokeWidth={2.5} />
      )}
      {shortId(uuid)}
    </button>
  );
}
